const ROBOTS_CONFIG = {
    dev: 'noindex, nofollow',
    tst: 'noindex, nofollow',
    acc: 'noindex, nofollow',
    prd: 'index, follow'
};

export const robots = ROBOTS_CONFIG[process.env.APP_ENV];